var React = require('react');
var Popover = require('patternity/lib/popover');
var i18n = require('../../../localization');
var { withNamespaces } = require('react-i18next');
var cn = require('classnames');

const OptionsIcon = () =>
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    style={{width: 24}}>
    <title>Options</title>
    <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path>
  </svg>;

var ChallengeCardOptions = React.createClass({
  displayName: "ChallengeCardOptions",

  PropTypes: {
    handleToggle : React.PropTypes.func.isRequired,
    isOpen : React.PropTypes.bool.isRequired,
    rewriteLook: React.PropTypes.bool
  },

  render : function(){
    const popoverStyle = {
      borderRadius: '5px',
      background: 'rgba(0,0,0,0)',
      borderColor: 'rgba(0,0,0,0)'
    };

    return (
      <div className="challenge-options">
        <Popover
          onClickOut={this._handleToggle}
          element={this._toggleButton()}
          isOpen={this.props.isOpen}
          position='bottom'
          style={popoverStyle}>
          <div className={cn({
            "challenge-options__list": true,
            "challenge-options__list__rewrite": this.props.rewriteLook
          })}>
            {this.props.children}
          </div>
        </Popover>
      </div>
    );
  },

  _toggleButton: function() {
    return (
      <a href="#" className={cn({"challenge-options__toggle": !this.props.rewriteLook})} onClick={this._onToggleClick}>
        <OptionsIcon />
        <span className="sr-only">{this.props.t('Options')}</span>
      </a>
    );
  },

  _handleToggle: function() {
    this.props.handleToggle();
  },

  _onToggleClick: function(e) {
    e.preventDefault();
    this._handleToggle();
  }
});

module.exports = withNamespaces()(ChallengeCardOptions);



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/challenge_card_options.jsx